import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import App from './App.jsx';
import * as Sentry from "@sentry/react";
import GlobalErrorBoundary from './components/common/GlobalErrorBoundary.jsx';

import {
  createBrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";
const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    
    // This associates errors with your project's version
    // You should set VITE_APP_RELEASE in your .env file
    release: `doctor-dashboard@${import.meta.env.VITE_APP_RELEASE || '1.0.0'}`,

    // This helps Sentry distinguish between dev and production
    environment: import.meta.env.MODE, // 'development' or 'production'

    integrations: [
      // Enables automatic breadcrumbs for browser events
      Sentry.browserTracingIntegration(),
      
      // Sentry's React Router v6 integration
      // This automatically creates performance traces for route changes
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),

      // Replay will record user sessions
      Sentry.replayIntegration({
        // Tweak privacy settings as needed
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],

    // --- Performance Monitoring ---
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0, // Capture 100% of transactions. Lower to 0.1 or less in production.

    // --- Session Replay ---
    // This sets the sample rate for session replay
    replaysSessionSampleRate: 0.1, // 10% of sessions will be recorded
    replaysOnErrorSampleRate: 1.0, // 100% of sessions with an error will be recorded

    // --- Target API for Tracing ---
    // Update this to match your production API routes
    tracePropagationTargets: ["localhost", /^\/api\//],

    // We'll keep PII off for now unless you specifically need it
    sendDefaultPii: false,

    // Enable logs to be sent to Sentry
    enableLogs: true,
  });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  //<React.StrictMode>
    <GlobalErrorBoundary>
      <App />
    </GlobalErrorBoundary>
  //</React.StrictMode>,
);